import React from "react";
import { Button, TextField } from "@mui/material";
import { useQuery } from "react-query";
import { myWalletFn } from "../../Services/UserAccount/MyWallet";
import { profileFn } from "../../Services/Authentication/Profile/UserProfile";
import { Info } from "@mui/icons-material";
import { useState } from "react";

const Earnings = () => {
  const [copy, setCopy] = useState(false);
  const [copyLink, setCopyLink] = useState(false);
  const { data: profile } = useQuery(["profile"], () => profileFn(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  const { data: myWallet } = useQuery(["myWallet"], () => myWalletFn(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
  const account = myWallet?.data?.data?.wallet?.[0];

  const copyText = document.getElementById("myInput");
  const copyTextLink = document.getElementById("myInputLink");

  const onCopy = () => {
    setCopy(true);
    copyText.select();
    navigator?.clipboard?.writeText(copyText.value);
  };
  const onCopyLink = () => {
    setCopyLink(true);
    copyTextLink.select();
    navigator?.clipboard?.writeText(copyTextLink.value);
  };
  return (
    <>
      <div className="bg-blue-800">
        <div className="py-5 px-3 flex gap-5 text-white  text-xl">
          My Earnings
        </div>
        <div className="py-10 text-center">
          <p className="text-white text-lg font-semibold"> Total Earnings</p>
          <p className="text-white text-3xl font-bold">{account?.balance}</p>
        </div>
        <div className="flex bg-white lg:flex-row flex-col-reverse justify-between pb-16 p-4">
          <div className="flex flex-col gap-3 lg:p-0 p-5 lg:w-1/2">
            <p className="text-xl font-semibold">Refer a friend</p>
            <p>
              Both can get{" "}
              {profile?.data?.data?.profile_data?.[0]?.referral_income} Coins
            </p>
            <p className="text-yellow-400 text-lg font-semibold">
              <Info /> How it works?
            </p>
            <span className="flex gap-3">
              <span className="rounded-full text-xl font-bold">1.</span>
              <span>
                <p>Invite Your Friends</p>
                <p>Share your link with them</p>
              </span>
            </span>
            <span className="flex gap-3">
              <span className="rounded-full text-xl font-bold">2.</span>
              <span>
                <p>Ask your friends to register.</p>
                <p>Both of you earn</p>
              </span>
            </span>

            <span className="flex gap-3">
              <span className="rounded-full text-xl font-bold">3.</span>
              <span>
                <p>You can save on your orders</p>
                <p>Your friend gets money too</p>
              </span>
            </span>
            <span>
              <p>Referral Code</p>
              <TextField
                color="error"
                id="myInput"
                size="small"
                value={
                  profile?.data?.data?.profile_data?.[0]?.user_referral_code
                }
                endDecorator={
                  <Button color="error" onClick={() => onCopy()}>
                    {copy ? "Copid!" : "Copy"}
                  </Button>
                }
                className="!w-full !p-0"
              />
            </span>
            <span>
              <p>Referral Link</p>
              <TextField
                id="myInputLink"
                color="error"
                size="small"
                value={profile?.data?.data?.profile_data?.[0]?.referral_link}
                endDecorator={
                  <Button color="error" onClick={() => onCopyLink()}>
                    {copyLink ? "Copid!" : "Copy"}
                  </Button>
                }
                className="!w-full !p-0"
              />
            </span>
          </div>
          {/* <img src={refer} alt="" className="lg:w-1/2" /> */}
        </div>
      </div>
    </>
  );
};
export default Earnings;
